<template>
  <ul>
    <h1>Testimonials</h1>
  </ul>
  <br />
  <div class="background container">
    <div class="row background2">
      <div class="col-6">
        <h3 id="testimonialName">Muhamad Abdul</h3>
        <p class="description" id="testimonialQuote">
          Jordan is a well-rounded individual and always extends his hand when
          others are in need, making him an exceptional team-player. Jordan is
          very resourceful and utilizes whatever resources at his disposal and
          applies it effectively within any project. I believe Jordan to be an
          important asset within the programming space.
        </p>
      </div>
      <div class="col-6 container">
        <div class="testimonial-thumb-wrapper align-contents-center">
          <button
            type="button"
            class="animate__animated wow animate__slideInRight"
            onclick="showTestimonial('Muhamad Abdul', 'Jordan is a well-rounded individual and always extends his hand when others are in need, making him an exceptional team-player. Jordan is very resourceful and utilizes whatever resources at his disposal and applies it effectively within any project. I believe Jordan to be an important asset within the programming space.')"
          >
            <img
              src="@/assets/testimonial/MuhamadAbdul.jpg"
              alt="Muhamad"
            />
          </button>
          <button type="button" class='animate__animated wow animate__slideInRight'  onclick="showTestimonial('Daniel Bowers', 'Jordan, oh...my man jordan.....none like him now a days if im going to be honest, his smart but also smart and has humour that cracks the space time continuum.....oh, Jordan')">
            <img src="@/assets/testimonial/Daniel.jpg" alt="img">
          </button>

          <button type="button" class='animate__animated wow animate__slideInRight'  onclick="showTestimonial('Kischa Thomas', 'This is Jordan he is a cool person who studies at life choices academy and he really enjoys doing coding.')">
            <img src="@/assets/testimonial/Kischa.jpg" alt="img">
          </button>

          <button type="button" class='animate__animated wow animate__slideInRight'  onclick="showTestimonial('Seth Kleynhans', 'This is Jordan he is a cool person who studies at life choices academy and he really enjoys doing coding.')">
            <img src="@/assets/testimonial/Seth.jpg" alt="img">
          </button>

          <button type="button" class='animate__animated wow animate__slideInRight'  onclick="showTestimonial('Godwin Dzvapatsva', 'Jordan has shown a remarkable development since joining the Lifechoices Academy. He is someone who listens and adjusts accordingly. Godwin -Head of Learning and Curriculum.')">
            <img src="@/assets/testimonial/Godwin.jpeg" alt="img">
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.background {
  background-color: red;
  margin: auto !important;
  padding: 15px;
  border-radius: 25px;
}
.background2 {
  background-color: rgba(0, 0, 124, 0.131);
  margin: auto !important;
  padding: 15px;
  border-radius: 25px;
}
h1 {
  text-decoration-line: underline;
  font-size: 30px;
}
h3{
    font-size: 36px;
    font-weight: 900;
    text-decoration-line: underline;
}
p {
  text-align: left;
  font-size: 22px;
}
img {
    width: 210px;
    height: 130px;
}
</style>
